import * as React from 'react'
import { useState, useRef, useEffect } from 'react'
import { BaseEmoji, Picker } from 'emoji-mart'
import { FieldInputProps, FormikHelpers, FormikValues } from 'formik'
import { useTranslation } from 'react-i18next'

import useOnClickOutside from '../../../hooks/useOnClickOutside'

import 'emoji-mart/css/emoji-mart.css'
import './textArea.sass'

interface Props {
    label?: string
    emoji?: boolean
    placeholder?: string
    field: FieldInputProps<string>
    form?: FormikHelpers<FormikValues>
    initValue?: string
}

const TextAreaWithEmoji: React.FunctionComponent<Props> = ({
    placeholder,
    field,
    label,
    form,
    emoji,
    initValue
}: Props) => {
    const [t] = useTranslation()
    const [showPicker, setShowPicker] = useState(false)
    const ref = useRef()

    // @ts-ignore
    useOnClickOutside(ref, () => setShowPicker(false))

    useEffect(() => {
        if (initValue) form.setFieldValue(field.name, initValue)
    }, [])

    return (
        <div className="textarea" ref={ref}>
            {label && <label htmlFor={field.name}>{t(label)}</label>}
            <div className="innerContainer">
                <textarea id={field.name} placeholder={t(placeholder)} {...field} />
                {emoji && <div className="pickerSwitcher" onClick={() => setShowPicker(!showPicker)} />}
            </div>
            {emoji && showPicker && (
                <Picker
                    style={{ position: 'absolute', bottom: '-340px', left: 'calc(100% - 390px)' }}
                    color="#104283"
                    showPreview={false}
                    include={['people', 'foods']}
                    onSelect={(emoji: BaseEmoji) => {
                        form.setFieldValue(field.name, field.value + ' ' + emoji.native)
                    }}
                />
            )}
        </div>
    )
}

export default TextAreaWithEmoji
